import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFolderOpen,
    faGear,
    faHome,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import FieldsListIcon from "./FieldsListIcon";

export const sentinelResourcesOption = {
    route: "/dashboard/resources",
    label: "Resources",
    component: ({ color }: { color: string }) => (
        <FontAwesomeIcon
            icon={faFolderOpen}
            size="2x"
            color={color}
            className="w-[31px]"
        />
    ),
};

export const cspResourcesOption = (organizationId: number) => ({
    route: `/dashboard/csp-portal/${organizationId}/resources`,
    label: "CSP Resources",
    component: ({ color }: { color: string }) => (
        <FontAwesomeIcon
            icon={faFolderOpen}
            size="2x"
            color={color}
            className="w-[31px]"
        />
    ),
});

export const NAV_BAR_OPTIONS = [
    {
        route: "/dashboard/home",
        component: ({ color }: { color: string }) => (
            <FontAwesomeIcon
                icon={faHome}
                size="2x"
                color={color}
                className="w-[31px]"
            />
        ),
        label: "Home",
    },
    {
        route: "/dashboard/fields",
        component: ({ color }: { color: string }) => (
            <FieldsListIcon color={color} />
        ),
        label: "Fields",
    },
    {
        route: "/dashboard/network",
        component: ({ color }: { color: string }) => (
            <FontAwesomeIcon
                icon={faUsers}
                size="2x"
                color={color}
                className="w-[31px]"
            />
        ),
        label: "Network",
    },
    {
        route: "/dashboard/account-settings",
        component: ({ color }: { color: string }) => (
            <FontAwesomeIcon
                icon={faGear}
                size="2x"
                color={color}
                className="w-[31px]"
            />
        ),
        label: "Settings",
    },
];
